"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _excluded = ["color", "strokeWidth", "className", "style", "size", "jss"];
var SIZE = 50;
var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: {
      display: 'flex'
    },
    spinner: {
      width: 'inherit',
      animation: '$spinnerRotate 2s linear infinite',
      transformOrigin: 'center center',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 0
    },
    size: {
      width: function width(_ref) {
        var size = _ref.size;
        return size;
      },
      height: function height(_ref2) {
        var size = _ref2.size;
        return size;
      }
    },
    color: {
      color: function color(_ref3) {
        var _color = _ref3.color;
        return _color || theme.palette.primary["default"];
      }
    },
    circle: {
      stroke: 'currentColor',
      strokeDasharray: '1, 100',
      strokeDashoffset: 0,
      animation: '$spinnerPathDash 1.5s ease-in-out infinite',
      strokeLinecap: 'round'
    },
    '@keyframes spinnerRotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes spinnerPathDash': {
      '0%': {
        strokeDasharray: '1, 200',
        strokeDashoffset: 0
      },
      '50%': {
        strokeDasharray: '89, 200',
        strokeDashoffset: '-35px'
      },
      '100%': {
        strokeDasharray: '89, 200',
        strokeDashoffset: '-124px'
      }
    }
  };
}, {
  name: 'Spinner'
});
exports.useStyles = useStyles;

var Spinner = /*#__PURE__*/_react["default"].forwardRef(function Spinner(_ref4, ref) {
  var color = _ref4.color,
      strokeWidth = _ref4.strokeWidth,
      className = _ref4.className,
      style = _ref4.style,
      size = _ref4.size,
      jss = _ref4.jss,
      props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
  var classes = useStyles({
    color: color,
    size: size,
    jss: jss
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])(classes.root, classes.color, classes.size, className),
    style: style
  }, props), /*#__PURE__*/_react["default"].createElement("svg", {
    className: (0, _classnames["default"])(classes.spinner),
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    className: classes.circle,
    cx: SIZE,
    cy: SIZE,
    r: "20",
    fill: "none",
    strokeWidth: strokeWidth,
    strokeMiterlimit: "10"
  })));
});

Spinner.defaultProps = {
  color: undefined,
  size: 40,
  className: '',
  style: {},
  strokeWidth: 3.6
};
Spinner.displayName = 'Spinner';
var _default = Spinner;
exports["default"] = _default;